:host {
  display: block;
}

#leftBlock--text {
    top: 40%;
    left: 12%;
    margin-right: 20%;
}

.card {
    width: 448px;
}

#main {
    height: calc(100vh - 102px);
}

#leftBlock--text {
    top: 40%;
    left: 12%;
    margin-right: 12%;
}

@media screen and (max-width: 768px) {

    #main {
        height: calc(100vh - 70px);
    }

    #leftBlock--text {
        left: 0;
        top: 15px;
        max-width: 448px;
        margin-left: calc((100vw - 448px) / 2);
        margin-right: 0;
    }

}

@media screen and (max-width: 477px) {
    #leftBlock--text {
        left: 0;
        top: 15px;
        margin-left: 15px;
        margin-right: 15px;
    }
}
